<form novalidate id="manualPay" #manualPayForm="ngForm">
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-3">
      <div class="flex-grow-1 select-field w-full">
        <label class="required">Payment Method</label>
        <select
          required
          name="PaymentMethod"
          [class.invalid]="PaymentMethod.invalid && isSubmitted && selectedPaymentMethod === ''"
          [disabled]="isProcessing"
          [ngModel]="selectedPaymentMethod"
          (ngModelChange)="setPaymentMethod($event)"
          #PaymentMethod="ngModel"
        >
          <ng-container *ngFor="let method of paymentMethods">
            <option
              *ngIf="method.enable"
              [ngValue]="method.value"
            >
              {{ method.name }}
            </option>
          </ng-container>
        </select>
      </div>

      <cj-form-field class="flex-grow-1 w-full">
        <cj-form-label>Payment Date</cj-form-label>
        <input
          cjInput
          fullWidth
          required
          type="date"
          name="PaymentDate"
          [disabled]="isProcessing"
          [min]="minPaymentDate"
          [status]="PaymentDate.invalid && isSubmitted && !isValidDate() ? 'danger' : ''"
          [ngModel]="paymentDate"
          (ngModelChange)="setPaymentDate($event)"
          #PaymentDate="ngModel"
        />
      </cj-form-field>
    </div>
    <cj-form-field>
      <cj-form-label>Transaction Reference</cj-form-label>
      <input
        cjInput
        fullWidth
        required
        type="text"
        name="TransactionReference"
        placeholder="0000 0000 0000 0000"
        [disabled]="isProcessing"
        [status]="TransactionReference.invalid && isSubmitted ? 'danger' : ''"
        [ngModel]="manualPayment.TransactionReference"
        (ngModelChange)="onChange('TransactionReference', $event)"
        #TransactionReference="ngModel"
      />
    </cj-form-field>
    <cj-form-field>
      <cj-form-label>Private Note</cj-form-label>
      <input
        cjInput
        fullWidth
        name="PrivateNotes"
        placeholder="Add your note here"
        [disabled]="isProcessing"
        [ngModel]="manualPayment.PrivateNotes"
        (ngModelChange)="onChange('PrivateNotes', $event)"
      />
    </cj-form-field>
    <cj-form-field class="flex-grow-1 w-full">
      <cj-form-label>Amount Due</cj-form-label>
      <input
        cjInput
        fullWidth
        readonly
        [value]="invoiceBalance | currency"
        [disabled]="isProcessing"
      />
    </cj-form-field>
  </div>
</form>